import React from 'react';
import {getEnvironment} from '../../app/App';
import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';
import withAutoplay from 'react-awesome-slider/dist/autoplay';

import AwesomeSliderStyles from 'react-awesome-slider/src/styles';

class Header extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            categories: [],products: [], promotions: [], productsPromotions: [], menu: [],
            json: '',
            // styles for categories
            backgroundColorCategory: '#9b9898', textColorCategory: '#ffffff', fontFamilyCategory: 'revert', colorIco: '#ffffff',backgroundColorInside: '#ffffff',
            // styles for promotions
            colorTitlePromotion: '#dc1111', fontFamilyPromotion: 'Helvetica Neue,Helvetica,Arial,sans-serif',
            colorDescriptionPromotion: '#64839f', fontFamilyDesPromotion: 'serif',
            badgePromotionBackground: '#18c235', badgePromotionColor: '#ffffff', badgePromotionFontF: 'Helvetica Neue,Helvetica,Arial,sans-serif',
            // styles for products
            backgroundColorProducts: '#ffffff',
            badgeProductsColor: '#ffffff', badgeProductsBackgroundColor: '#1072b8', badgeProductFontF: 'Helvetica Neue,Helvetica,Arial,sans-serif',
            descriptionColorProducts: '#797d8a', descriptionFontFamily: 'serif', titleColorProducts: '#0a5184', titleFontFamily: 'Helvetica Neue,Helvetica,Arial,sans-serif',
            badgeNoDisColor: '#ffffff',badgeNoDisBackground: '#da1919',badgeNoDisFontF: 'sans-serif'



        }

    }

    componentDidMount(){
        this.getMenuItems();
        this.getCardsItems();
        this.getPromotions();
        this.getMenu();
    }

    getMenuItems() {
        console.log("idMenu: ", window.sessionMenu.idMenu);
        var idMenu = window.sessionMenu.idMenu;
        const axios = require('axios');
        var datos = new FormData();
        datos.append("idMenu", idMenu);
        let that = this;
        var confCurrent = getEnvironment();
        axios.post(confCurrent.home + 'a/get/menu/products/' + Date.now(), datos)
        .then(function (response) {
            console.log("products: ",response);
            if(response.data.data.Products != null && response.data.data.Products !== ''){
                that.setState({ products: response.data.data.Products });
                //console.log("nameCompany: ",response.data.data.Menu[0].name);
            } else {
                that.setState({ products: []});
            }
        })
            .catch(function (error) {
            console.log(error);
        });
    }

    getPromotions() {
        console.log("idMenu: ", window.sessionMenu.idMenu);
        var idMenu = window.sessionMenu.idMenu;
        const axios = require('axios');
        var datos = new FormData();
        datos.append("idMenu", idMenu);
        let that = this;
        var confCurrent = getEnvironment();
        axios.post(confCurrent.home + 'a/get/menu/promotions/' + Date.now(), datos)
        .then(function (response) {
            console.log("Promotions: ",response);
            if(response.data.data.Promotions != null && response.data.data.Promotions !== ''){
                that.setState({ promotions: response.data.data.Promotions, activePromotions: response.data.data.Promotions[0].Menu.activePromotions });
                //console.log("nameCompany: ",response.data.data.Menu[0].name);
            } else {
                that.setState({ promotions: []});
            }
        })
            .catch(function (error) {
            console.log(error);
        });
    }

    getCardsItems() {
        console.log("idMenu: ", window.sessionMenu.idMenu);
        var idMenu = window.sessionMenu.idMenu;
        const axios = require('axios');
        var datos = new FormData();
        datos.append("idMenu", idMenu);
        let that = this;
        var confCurrent = getEnvironment();
        axios.post(confCurrent.home + 'a/get/menu/categories/' + Date.now(), datos)
        .then(function (response) {
            console.log("categories: ",response);
            if(response.data.data.MenuCategories != null && response.data.data.MenuCategories !== ''){
                that.setState({ categories: response.data.data.MenuCategories });
            } else {
                that.setState({ categories: []});
            }
        })
            .catch(function (error) {
            console.log(error);
        });
    }


    getMenu() {
        console.log("idMenu: ", window.sessionMenu.idMenu);
        var idMenu = window.sessionMenu.idMenu;
        const axios = require('axios');
        var datos = new FormData();
        datos.append("idMenu", idMenu);
        let that = this;
        var confCurrent = getEnvironment();
        axios.post(confCurrent.home + 'a/get/menu/' + Date.now(), datos)
        .then(function (response) {
            console.log("menu json: ",response);
            if(response.data.data.Menu != null && response.data.data.Menu !== ''){
                that.setState({ json: response.data.data.Menu[0].style});
                console.log("json: ",that.state.json);

                var json = JSON.parse(that.state.json);
                //console.log("json: ",json);

                that.setState({ // styles for category
                                json: json,
                                backgroundColorCategory: json.menu.categories.header.backgroundColor,
                                textColorCategory:  json.menu.categories.header.text.color,
                                fontFamilyCategory: json.menu.categories.header.text.fontFamily,
                                backgroundColorInside: json.menu.categories.backgroundColorInside,
                                colorIco: json.menu.categories.header.arrowColor,
                                // styles for promotions
                                colorTitlePromotion: json.menu.promotions.text.title.color,
                                fontFamilyPromotion: json.menu.promotions.text.title.fontFamily,
                                colorDescriptionPromotion: json.menu.promotions.text.description.color,
                                fontFamilyDesPromotion: json.menu.promotions.text.description.fontFamily,
                                badgePromotionBackground: json.menu.promotions.badgePrice.backgroundColor,
                                badgePromotionColor: json.menu.promotions.badgePrice.color,
                                badgePromotionFontF: json.menu.promotions.badgePrice.fontFamily,
                                // styles for products
                                backgroundColorProducts: json.menu.products.backgroundColor,
                                badgeProductsColor: json.menu.products.badgePrice.color,
                                badgeProductsBackgroundColor: json.menu.products.badgePrice.backgroundColor,
                                badgeProductFontF: json.menu.products.badgePrice.fontFamily,
                                descriptionColorProducts: json.menu.products.text.description.color,
                                descriptionFontFamily: json.menu.products.text.description.fontFamily,
                                titleColorProducts: json.menu.products.text.title.color,
                                titleFontFamily: json.menu.products.text.title.fontFamily,
                                badgeNoDisColor: json.menu.products.badgeNoDisponible.color,
                                badgeNoDisBackground: json.menu.products.badgeNoDisponible.backgroundColor,
                                badgeNoDisFontF: json.menu.products.badgeNoDisponible.fontFamily,

                            });

            } else {
                that.setState({ json: []});
            }
        })
            .catch(function (error) {
            console.log(error);
        });
    }


    getDataProducts(idMenuCategories){
        var confCurrent = getEnvironment();

        const badgeStyle = {color: this.state.badgeProductsColor, backgroundColor: this.state.badgeProductsBackgroundColor, fontFamily: this.state.badgeProductFontF}

        const badgeStyleNoDis = {color: this.state.badgeNoDisColor, backgroundColor: this.state.badgeNoDisBackground, fontFamily: this.state.badgeNoDisFontF}

        const descriptionStyle = {color: this.state.descriptionColorProducts,fontFamily: this.state.descriptionFontFamily }
        const titleStyle = {color: this.state.titleColorProducts,fontFamily: this.state.titleFontFamily }
        const backgroundCard = {background: this.state.backgroundColorProducts }

        const products = [];
        for(var x=0;x < this.state.products.length;x++){
            const product = this.state.products[x];
            if(product.MenuCategories.idMenuCategories === idMenuCategories){
                var n = product.description.length;
                //console.log("count caracteres: ",n);
                var badgedis = 'dis-badbe';
                var price= '';
                if(product.idStatus == 2 || product.idStatus == 3){
                    badgedis = '';
                }

                if(product.price == 0){
                    price = 'Preguntar precio';
                } else {
                    price = '$ ' + product.price;
                }

                if(product.urlImg == 'url') {
                    products.push(
                        <div className="col-sm-6 col-md-6 col-lg-3" key={product.idMenuProducts}>
                            <div className="card wd-menu">
                                <div className="card-body" style={backgroundCard}>
                                    <h5 className="txt-name-product pt-1 txt-captlize" style={titleStyle} >{product.name}</h5>
                                    <p className="card-text txt-description-product description" style={descriptionStyle} dangerouslySetInnerHTML={ {__html: product.description}  } ></p>
                                </div>
                                <div className="crd-footer" style={backgroundCard}>&nbsp;&nbsp;&nbsp;
                                    <span className={"badge badge-nodis " + badgedis} style={badgeStyleNoDis} >No disponible</span>
                                    <span className="badge badge-price float-right" style={badgeStyle}>{price}</span>
                                  </div>
                            </div>
                        </div>
                    );
                } else {
                    products.push(
                        <div className="col-sm-6 col-md-6 col-lg-3" key={product.idMenuProducts}>
                            <div className="card wd-menu-img">
                                <a href={confCurrent.home + "assets/images/directory/" + product.urlImg} data-lightbox={'roadtrip_' + product.idMenuProducts} data-title="">
                                    <img className="card-img-top img-product" src={confCurrent.home + "assets/images/directory/" + product.urlImg} alt="Card image cap" />
                                 </a>
                                <div className="card-body" style={backgroundCard}>
                                    <h5 className="txt-name-product pt-1 txt-captlize" style={titleStyle} >{product.name}</h5>
                                    <p className="card-text txt-description-product description" style={descriptionStyle} dangerouslySetInnerHTML={ {__html: product.description}  } ></p>
                                </div>
                                <div className="crd-footer" style={backgroundCard}>&nbsp;&nbsp;&nbsp;
                                    <span className={"badge badge-nodis " + badgedis} style={badgeStyleNoDis} >No disponible</span>
                                    <span className="badge badge-price float-right" style={badgeStyle}>{price}</span>
                                </div>
                            </div>
                        </div>
                    );
                }
            }
        }
        return products;
    }


    getPromotionData(idMenuCategories) {
        var confCurrent = getEnvironment();
        const textTitle = {color: this.state.colorTitlePromotion, fontFamily: this.state.fontFamilyPromotion}
        const textDescription = {color: this.state.colorDescriptionPromotion, fontFamily: this.state.fontFamilyDesPromotion, lineHeight: 'initial'}
        var badgeStyle = '';

        const promotion = [];
        for(var x=0;x < this.state.products.length;x++){
            const product = this.state.products[x];
            var act = '';
            if(product.order == 1) {
                act = 'active';
            }

            var price = '';
            if(product.price == 0){
                price = 'Preguntar precio';
                badgeStyle = { color: this.state.badgePromotionColor, backgroundColor: this.state.badgePromotionBackground,fontFamily: this.state.badgePromotionFontF, width: '125px' }
            } else {
                price = '$ ' + product.price;
                badgeStyle = {color: this.state.badgePromotionColor, backgroundColor: this.state.badgePromotionBackground,fontFamily: this.state.badgePromotionFontF };
            }

            if(product.MenuCategories.idMenuCategories === idMenuCategories){
                promotion.push(
                    <div className={"carousel-item " + act} key={product.idMenuProducts}>
                        <div className="card mb-c crd-sli">
                            <div className="card-body dis-bdy-mod">
                                <div className="row">
                                    <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                                        <a className="" href="#multi-item-example" data-slide="prev"><i className="fas fa-chevron-left ft-ico"></i></a>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-3 col-xs-6">
                                        <a href={confCurrent.home + "assets/images/directory/" + product.urlImg} data-lightbox={'roadtrip_' + product.idMenuProducts} data-title="">
                                            <img className="card-img-top img-promotion" src={confCurrent.home + "assets/images/directory/" + product.urlImg} alt="Card image cap" />
                                        </a>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-7 col-xs-6">
                                        <h4 className="pt-1 txt-name-p txt-captlize" style={textTitle} >{product.name}</h4>
                                        <p className="card-text txt-description-p" style={textDescription} >{product.description}</p>
                                    </div>
                                    <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                                        <a className="btn-floating" href="#multi-item-example" data-slide="next"><i className="fas fa-chevron-right pl-1 ft-ico"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body dis-bdy">
                                <div className="row">
                                    <div className="col-sm-5">
                                        <a href={confCurrent.home + "assets/images/directory/" + product.urlImg} data-lightbox={'roadtrip_' + product.idMenuProducts} data-title="">
                                            <img className="card-img-top img-promotion" src={confCurrent.home + "assets/images/directory/" + product.urlImg} alt="Card image cap" />
                                        </a>
                                    </div>
                                    <div className="col-sm-7 wd-cnt-prom">
                                        <h4 className="pt-1 txt-name-p txt-captlize" style={textTitle} >{product.name}</h4>
                                        <p className="card-text txt-description-p" style={textDescription}>{product.description}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="crd-footer b-rd">
                                <span className="badge badge-price-p float-right" style={badgeStyle}>{price}</span>
                            </div>
                        </div>
                    </div>
                );
            }
        }

        return promotion;
    }



    render (){
        var confCurrent = getEnvironment();

        const sCatBackground = {backgroundColor: this.state.backgroundColorCategory};
        const textColorCategory = {color: this.state.textColorCategory, fontFamily: this.state.fontFamilyCategory};
        const colorIco = {color: this.state.colorIco}
        const backgroundColorInside = {backgroundColor: this.state.backgroundColorInside}

        const menuCategories = [];
        for(var x=0;x < this.state.categories.length;x++){
        const cat = this.state.categories[x];
            menuCategories.push(
                <div className="col-lg-12 col-md-12 col-sm-12 wd-limk" key={cat.idMenuCategories}>
                    <div  className="property_item classical-list">
                        <div  className="pd-menu" id="category" style={sCatBackground} >
                           <a className="txt-cats collapsed txt-right" style={textColorCategory} data-toggle="collapse" data-target={"#collapse_" + cat.idMenuCategories} aria-expanded="false" aria-controls="collapseCatItems">{cat.name}
                                <i className="fas fa-chevron-down float-right" style={colorIco}></i>
                            </a>
                        </div>
                        <div className="collapse pd-bd-card in" id={"collapse_" + cat.idMenuCategories} style={backgroundColorInside}>
                            <div className="row pt-1">
                                {this.getDataProducts(cat.idMenuCategories)}
                            </div>
                        </div>
                    </div>
                </div>
            );

        }

        const menuProducts = [];
        for(var x=0;x < this.state.promotions.length;x++){
        const promotions = this.state.promotions[x];
        var cpromotions = '';
            if(promotions.Menu.activePromotions == 0){
                 cpromotions = 'dis-promotion';
            }

            menuProducts.push(
                <div className={"row p-rw " + cpromotions} key={promotions.idMenuCategories}>
                    <div className="col-md-2 col-lg-3 col-sm-1"></div>
                    <div className="col-md-8 col-lg-6 col-sm-10">
                        <div id="multi-item-example" className="box-sli carousel slide carousel-multi-item slider-cards-down" data-ride="carousel">
                            <ol className="carousel-indicators dis-indicators">
                                <li data-target="#multi-item-example" data-slide-to="0" className="active"></li>
                                <li data-target="#multi-item-example" data-slide-to="1"></li>
                                <li data-target="#multi-item-example" data-slide-to="2"></li>
                            </ol>
                            <div className="carousel-inner" role="listbox">
                                {this.getPromotionData(promotions.idMenuCategories)}
                            </div>
                            <a className="" href="#multi-item-example" data-slide="prev"><i className="fas fa-chevron-left pd-ico dis-ico-f ico-size dis-promotion"></i></a>
                            <a className="" href="#multi-item-example" data-slide="next"><i className="fas fa-chevron-right dis-ico-f  pl-1 ico-size dis-promotion"></i></a>
                        </div>


                    </div>
                    <div className="col-md-2 col-lg-3 col-sm-1"></div>
                </div>
            );
        }

        const AutoplaySlider  = withAutoplay(AwesomeSlider);

        return (
            <React.Fragment>

                {menuProducts}

                <div className="row">
                    {menuCategories}
                </div>

            </React.Fragment>
        )
    }
}

export default Header;
